import { lazy } from "react";

const create = lazy(() => import("./Create").then(m => ({ default: m.OrganizationCreate })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.OrganizationEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.OrganizationList })));

export default { create, edit, list };
